import { render, staticRenderFns } from "./MarkedItemsManager.vue?vue&type=template&id=0e531c3d&scoped=true&"
import script from "./MarkedItemsManager.vue?vue&type=script&lang=js&"
export * from "./MarkedItemsManager.vue?vue&type=script&lang=js&"
import style0 from "./MarkedItemsManager.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MarkedItemsManager.vue?vue&type=style&index=1&id=0e531c3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e531c3d",
  null
  
)

component.options.__file = "MarkedItemsManager.vue"
export default component.exports